const dictionary = {
  parliamentaryGroups: {
    BD: "PBD",
    CE: "PDC",
    G: "Verts",
    GL: "Vert'lib",
    RL: "PLR",
    S: "PS",
    V: "UDC"
  },
  answers: {
    0: "/",
    1: "oui",
    2: "non",
    3: "abst"
  }
};

export default dictionary;
